<template>
<img class="wbot-icon" src="@/assets/images/wbot.svg" @click="handleClick" />
</template>
<script>
export default {
  name: 'WbotIcon',
  methods: {
    handleClick() {
      window.open('https://wbot.bpsheab.com/')
    }
  }
}
</script>
<style scoped>
.wbot-icon {
  width: 80px;
  height: 80px;
  position: fixed;
  right: 16px;
  bottom: 10%;
  z-index: 9999;
  cursor: pointer;
}
</style>
